module.exports = __webpack_public_path__ + "assets/img/fefc28924b6c640e687e19a1a3f14ac8.webp";